export let declarativeElementRequired = false;
export function requireAllCustomElementsToBeDeclarativeElements() {
    declarativeElementRequired = true;
}
